export const DEFAULT_MODULES = {
  dashboard: true,
  receiving: true,
  wip: true,
  shipping: true,
  products: true,
  inventory: true,
  traceability: true,
  qa: true,
  lab_samples: true,
  assistant: true,
};

export const MODULE_OPTIONS = [
  { key: "dashboard", label: "Dashboard" },
  { key: "receiving", label: "Receiving" },
  { key: "wip", label: "WIP" },
  { key: "shipping", label: "Shipments" },
  { key: "products", label: "Products" },
  { key: "inventory", label: "Inventory" },
  { key: "traceability", label: "Traceability" },
  { key: "qa", label: "QA Reports" },
  { key: "lab_samples", label: "Lab Samples" },
];

export function tenantModules(tenant) {
  return { ...DEFAULT_MODULES, ...(tenant?.settings?.modules ?? {}) };
}

export function moduleEnabled(tenant, key) {
  const modules = tenant?.settings?.modules;
  if (!modules) {
    return DEFAULT_MODULES[key] !== false;
  }
  return modules[key] !== false;
}
